import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const KidsPartiesPage: React.FC = () => {
  return <EventPageTemplate {...eventData.kids} />;
};

export default KidsPartiesPage;